import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, withDefaults } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import { EyeIcon, EyeOffIcon } from "@heroicons/vue/solid"

interface Props {
    modelValue?: string
    label?: string
    required?: boolean
    name?: string
    autocomplete?: string
    invalid?: boolean
    errorMessage?: string
    showRequired?: boolean
    disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsPasswordInput',
  props: {
    modelValue: { default: "" },
    label: { default: "Password" },
    required: { type: Boolean, default: false },
    name: { default: "password" },
    autocomplete: { default: "current-password" },
    invalid: { type: Boolean },
    errorMessage: {},
    showRequired: { type: Boolean, default: true },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props



const password = ref(props.modelValue)
const showPassword = ref(false)

const passwordInputType = computed(() => {
    return showPassword.value ? "text" : "password"
})

const passwordInputIcon = computed(() => {
    return password.value?.length ? (showPassword.value ? EyeOffIcon : EyeIcon) : undefined
})

function togglePasswordVisibility() {
    showPassword.value = !showPassword.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GgmsInput, {
    modelValue: password.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', password.value)))
    ],
    showRequired: _ctx.showRequired,
    iconEnd: passwordInputIcon.value,
    type: passwordInputType.value,
    name: _ctx.name,
    label: _ctx.label,
    required: _ctx.required,
    autocomplete: _ctx.autocomplete,
    invalid: _ctx.invalid,
    errorMessage: _ctx.errorMessage,
    disabled: _ctx.disabled,
    showIconEnd: true,
    onClickIconEnd: togglePasswordVisibility
  }, null, 8, ["modelValue", "showRequired", "iconEnd", "type", "name", "label", "required", "autocomplete", "invalid", "errorMessage", "disabled"]))
}
}

})